// V96 — Service web : notifications pharmacien centralisées (in-app realtime).

import { supabase } from '../lib/supabase'

export type NotifCategory =
  | 'adherence'
  | 'low_rating'
  | 'adverse_event'
  | 'supplier_credit'
  | 'stockout'
  | 'leave_request'
  | 'other'

export type NotifSeverity = 'low' | 'medium' | 'high' | 'critical'

export interface PharmacistNotification {
  id: string
  pharmacy_id: string
  user_id: string | null
  category: NotifCategory
  severity: NotifSeverity
  title: string
  body: string | null
  link_route: string | null
  reference_id: string | null
  reference_type: string | null
  read_at: string | null
  read_by: string | null
  created_at: string
}

export const listPharmacistNotifications = async (
  onlyUnread = false,
  limit = 50,
): Promise<PharmacistNotification[]> => {
  const { data, error } = await supabase.rpc(
    'list_pharmacist_notifications' as never,
    { p_only_unread: onlyUnread, p_limit: limit } as never,
  )
  if (error) throw error
  return (data ?? []) as PharmacistNotification[]
}

export const countUnreadPharmacistNotifications = async (): Promise<number> => {
  const { data, error } = await supabase.rpc(
    'count_unread_pharmacist_notifications' as never,
  )
  if (error) throw error
  return (data as number) ?? 0
}

export const markNotificationRead = async (id?: string): Promise<void> => {
  const { error } = await supabase.rpc(
    'mark_pharmacist_notification_read' as never,
    { p_id: id ?? null } as never,
  )
  if (error) throw error
}
